import { useSnackbar } from 'notistack';
import { BaseResponse } from 'library/types';
import ConfirmDialog from 'components/confirm-dialog';
import { Dispatch, ReactNode, SetStateAction, useState } from 'react';
import { GridRowId, GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteDialogProps = {
  open: boolean;
  id: GridRowId;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
  title: ReactNode;
  subTitle: ReactNode;
  action: (id: number) => Promise<BaseResponse<{}>>;
  successMessage: ReactNode;
};

const DeleteDialog = ({
  open,
  id,
  handleClose,
  refresh,
  setRowSelectionModel,
  title,
  subTitle,
  action,
  successMessage,
}: DeleteDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    try {
      setLoading(true);

      const response = await action(Number(id));

      if (response.isSuccess) {
        enqueueSnackbar(successMessage, { variant: 'success' });
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={open}
      title={title}
      description={subTitle}
      onClose={handleClose}
      onConfirm={handleDelete}
      loading={loading}
      mobileFullScreen={false}
    />
  );
};

export default DeleteDialog;
